import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const BookingHistory = () => {
    const formatDate = (date) => {
        const d = new Date(date);
        const day = (`0${d.getDate()}`).slice(-2);
        const month = (`0${d.getMonth() + 1}`).slice(-2);
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [packageList, setPackageList] = useState([]);
  const [is_discount, setIsDiscount] = useState(1);
  const [fromDate, setFromDate] = useState(formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)));
  const [toDate, setToDate] = useState(formatDate(new Date()));
  const [selectedPayment, setSelectedPayment] = useState("");
   const [show, setViewMod] = useState(false);
   const [service, setServicePopup] = useState(false);
   const [serviceData, setServices] = useState([]);
   const [selectedOrder, setSelectedOrder] = useState([]);
   const [couponModal, setCouponModal] = useState(false);
const [couponData, setCouponData] = useState(null);


  useEffect(() => {
    fetchbookinghistory();
}, [currentPage,fromDate, toDate]);

const showCouponDetails = (coupon) => {
  setCouponData(coupon);
  setCouponModal(true);
};
const fetchbookinghistory = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/shop-booking-detail-history/${fromDate}/${toDate}`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setPackageList(response.data.reverse());
      setIsLogin(false);
  } catch (error) {
    setPackageList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredEmployees = Array.isArray(packageList) && packageList.filter(pack => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (pack.token_no && pack.token_no.toString().toLowerCase().includes(searchLower)) ||
      (pack.customer_name && pack.customer_name.toString().toLowerCase().includes(searchLower)) ||
      (pack.customer_phone && pack.customer_phone.toString().toLowerCase().includes(searchLower)) ||
      (pack.email_id && pack.email_id.toString().toLowerCase().includes(searchLower)) ||
      (pack.booking_date && pack.booking_date.toString().toLowerCase().includes(searchLower)) ||
      (pack.booking_time && pack.booking_time.toString().toLowerCase().includes(searchLower)) ||
      (pack.slot_time && pack.slot_time.toString().toLowerCase().includes(searchLower)) 
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

  const handleCheckboxChange = (e) => {
    setIsDiscount(e.target.checked ? 1 : 0); // Update is_active based on checkbox status
  };

  const convertTo12Hour = (time) => {
    if (!time) return "";
    const [hour, minute] = time.split(":");
    const suffix = +hour >= 12 ? "PM" : "AM";
    const hour12 = +hour % 12 || 12;
    return `${hour12}:${minute} ${suffix}`;
  };

  const handleCloseModal = () => setViewMod(false);
  const handleCloseModalService = () => setServicePopup(false);

  const openPayChoice = (data) => {
   setViewMod(true);
    setSelectedOrder(data);  // Set the selected order data
    console.log('ddd', data, selectedOrder);  // Log the selected order
  };
  
  // Confirm Payment
  const confirmPayment = () => {
    if (!selectedPayment) {
      Swal.fire({
        title: "Error!",
        text: `Select Payment Type`,
        icon: "error",
        confirmButtonColor: "#34c38f",
      });
    } else {
      // Call handlePayment with the currently selected payment option
      handlePayment(selectedPayment);
    }
  };

  // Handle Payment Type
  const handlePayment = (paymentType) => {
    if (paymentType === "3") {
      // If SQ QR is selected, open Razorpay
      openRazorpay();
    } else {
      // For Cash and Shop QR, call the update API directly
      updatePayment(paymentType);
    }
  };

  // Open Razorpay Payment Gateway
  const openRazorpay = () => {
    const options = {
      key: "rzp_live_pjBqmpZwxNqOn2", // Add your Razorpay key here
      key_secret: "FdhDNbFA0AqCFvPVNNIpQfQ7", // Add your Razorpay secret here
      amount: selectedOrder.total_amount * 100, // Using item.plan_cost
      currency: "INR",
      name: "SQ QR", // Using item.plan_name
      description: "for booking payment",
      handler: (response) => {
        // Payment successful, call the update API
        updatePayment("3", response);
      },
      prefill: {
        name: selectedOrder.customer_name,
        email: selectedOrder.customer_email,
        contact: selectedOrder.customer_phone,
      },
      notes: {
        address: "Razorpay Corporate office",
      },
      theme: {
        color: "#F37254",
      },
    };

    // Create a new Razorpay instance and open the payment modal
    const pay = new window.Razorpay(options);
    pay.open();
  };

  // Update Payment Status via API
  const updatePayment = (paymentType, response = null) => {
    const tokens = localStorage.getItem("token");
    const payload = {
      payment_type: parseInt(paymentType),
      transaction_id: response ? response.razorpay_payment_id : "-", // Optional: pass the Razorpay response if needed
      paid_amount: selectedOrder.total_amount,
      payment_status: 1,
    };

    // Make your API call here
    axios
      .put(`${var_api}/api/booking/put/${selectedOrder.booking_id}`, payload, {
        headers: {
          Authorization: `${tokens}`,
        },
      })
      .then((res) => {
        // Reset the selected payment and close the modal
        setSelectedPayment(null);
        fetchbookinghistory();
        handleCloseModal();
        console.log("Update successful:", res.data);
        // Reload or update the booking list if needed
      })
      .catch((error) => {
        console.error("Update failed:", error);
        if (error.response && error.response.status === 401) {
          // Handle Unauthorized error
        //   window.location.href = redirect; // Adjust to your redirect URL
        } else {
          console.error(error);
        }
      });
  };

const showServices = (data) => {
    setServicePopup(true);
    setServices(data);
};


    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       BOOKING HISTORY
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none",padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                <div className="row align-items-center">
  <div className="col-md-3">
    <label style={{ color: "rgba(103, 120, 95)" }}>From Date:</label>
    <input
      type="date"
      placeholder="From time"
      className="form-control"
      value={fromDate.split('-').reverse().join('-')}
      onChange={(e) => setFromDate(e.target.value.split('-').reverse().join('-'))}
      style={{marginBottom:'5px'}}
    />
  </div>
  <div className="col-md-3">
    <label style={{ color: "rgba(103, 120, 95)" }}>To Date:</label>
    <input
      type="date"
      placeholder="To time"
      className="form-control"
      value={toDate.split('-').reverse().join('-')}
      onChange={(e) => setToDate(e.target.value.split('-').reverse().join('-'))}
      style={{marginBottom:'5px'}}
    />
  </div>
  <div className="col-md-6 d-flex justify-content-end align-items-center">
    <Form.Control
      type="text"
      placeholder="Search..."
      className="form-control"
      onChange={handleSearchInput}
      style={{ maxWidth: "300px" }}
    />
  </div>
</div>
                 <Table responsive className="table align-middle table-nowrap">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Token No</th>
            <th>Name</th>
            <th>Mobile</th>
            <th>Email ID</th>
            <th>Booking Date</th>
            <th>Booking Time</th>
            <th>Slot Time</th>
            <th>Booking Status</th>
            <th>Total Services</th>
            <th>Payment Status</th>
            <th>Total Amount</th>
            <th>Paid Amount</th>
            <th>Payment Type</th>
            <th>Transaction ID</th>
            <th>Coupon Booking</th>
            <th>Membership Booking</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedFilteredEmployees.length > 0 ? (
            paginatedFilteredEmployees.map((data, index) => (
              <tr key={data.id}>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td>
                <div style={{width: '30px',height: '30px',borderRadius: '50%', backgroundColor: '#3498db25', color: '#3498db',
                 display: 'inline-flex', justifyContent: 'center', alignItems: 'center', fontSize: '14px',fontWeight: 'bold',}}>
                    {data.token_no}
                </div>
                </td>
                <td>{data.customer_name}</td>
                <td>{data.customer_phone}</td>
                <td>{data.email_id}</td>
                <td>{data.booking_date}</td>
                <td>{data.booking_time}</td>
                <td>{data.slot_time}</td>
                <td>
                  <Button
                    variant={
                      data.status === 1
                        ? "primary"
                        : data.status === 2
                        ? "warning"
                        : data.status === 3
                        ? "success"
                        : "secondary"
                    }
                    style={{ borderRadius: "30px" }}
                  >
                    {data.status === 0
                      ? "Waiting"
                      : data.status === 1
                      ? "Running"
                      : data.status === 2
                      ? "Skipped"
                      : data.status === 3
                      ? "Completed"
                      : "Unknown"}
                  </Button>
                </td>
                <td>
                  <p
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => showServices(data.services)}
                  >
                    {data.services.length} {data.services.length > 1 ? 'Services': 'Service'}
                  </p>
                </td>
                <td>
                  <p
                    className={data.payment_status === 1 ? "text-success" : "text-danger"}
                  >
                    {data.payment_status === 1 ? "Paid" : "Not Paid"}
                  </p>
                </td>
                <td>{data.total_amount}</td>
                <td>{data.paid_amount}</td>
                <td>
                  {data.payment_type === 1
                    ? "CASH"
                    : data.payment_type === 2
                    ? "Shop QR"
                    : data.payment_type === 3
                    ? "SQ QR"
                    : "None"}
                </td>
                <td>{data.transaction_id}</td>
                <td>
  {data.is_coupon === 1 ? (
    <p 
      className="text-primary" 
      style={{ cursor: "pointer" }}
      onClick={() => showCouponDetails(data.coupon)}
    >
      Yes
    </p>
  ) : (
    <p className="text-danger">No</p>
  )}
</td>
                <td>
                  <p
                    className={data.is_coupon === 2 ? "text-success" : "text-danger"}
                  >
                    {data.is_coupon === 2 ? "Yes" : "No"}
                  </p>
                </td>
                <td>
                  {data.payment_status === 0 && data.status === 0 ? (
                    <Button
                      variant="warning"
                      style={{ borderRadius: "25px" }}
                      onClick={() => openPayChoice(data)}
                    >
                      PAY NOW
                    </Button>
                  ) : (
                    <p>No action here</p>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="18" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
            <Modal show={service} onHide={handleCloseModalService} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Services</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <Table striped bordered hover className="align-middle mb-0">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Service Name</th>
                <th>Price</th>
                <th>Service Duration</th>
                <th>From Time</th>
                <th>To Time</th>
              </tr>
            </thead>
            <tbody>
              {serviceData && serviceData.length > 0 ? (
                serviceData.map((data, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data.service_name}</td>
                    <td>{data.price}</td>
                    <td>{data.duration}</td>
                    <td>{convertTo12Hour(data.from_time)}</td>
                    <td>{convertTo12Hour(data.to_time)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>

    <Modal show={couponModal} onHide={() => setCouponModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Coupon Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {couponData ? (
      <div>
        <p><strong>Name:</strong> {couponData.name}</p>
        <p><strong>Code:</strong> {couponData.code}</p>
        <p><strong>Description:</strong> {couponData.description}</p>
        <p><strong>Discount Type:</strong> {couponData.discount_type === 1 ? 'Percentage' : 'Fixed Amount'}</p>
        <p><strong>Discount Value:</strong> {couponData.discount_value}{couponData.discount_type === 1 ? '%' : ''}</p>
        <p><strong>Valid From:</strong> {couponData.from_date}</p>
        <p><strong>Valid To:</strong> {couponData.to_date}</p>
      </div>
    ) : (
      <p>No coupon data available</p>
    )}
  </Modal.Body>
</Modal>

    <Modal show={show} onHide={handleCloseModal} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title className="text-uppercase">Payment Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="p-3">
          <Form.Check
            type="radio"
            label="Cash"
            name="paymentOptions"
            value="1"
            onChange={(e) => setSelectedPayment(e.target.value)}
          />
          {/* <Form.Check
            type="radio"
            label="SQ QR"
            name="paymentOptions"
            value="3"
            onChange={(e) => setSelectedPayment(e.target.value)}
          /> */}
          <Form.Check
            type="radio"
            label="Shop QR"
            name="paymentOptions"
            value="2"
            onChange={(e) => setSelectedPayment(e.target.value)}
          />
          <Button
            variant="success"
            style={{ borderRadius: "10px", width: "200px" }}
            onClick={() => confirmPayment(selectedPayment)}
            className="mt-3"
          >
            Confirm
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
        </div>
        </>
    )
}

export default BookingHistory;